import { useCheckSession, useUserData } from "../features/auth";
import handleUpdateSessionAllWindows from "../utils/handleUpdateSessionAllWindows";

export const useAuthInit = () => {
  const {
    data: isAuth,
    isLoading: isLoadingSession,
    isSuccess: isSessionChecked,
  } = useCheckSession();

  const {
    data: userData,
    isLoading: isLoadingUser,
  } = useUserData(isAuth === true);

  // Handle multi-window session sync
  handleUpdateSessionAllWindows();

  return {
    isAuth: isAuth ?? false,
    isLoading: isLoadingSession || (isAuth && isLoadingUser),
    isSessionChecked,
    userData,
  };
};
